import React from "react";

function Loader() {
    return (
        <div id="loader">
            Prašome palaukti...
        </div>
    );
}

export default Loader;